import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import api from "./api";
import auth from "./auth";




export default function PrivateRouteAdm({ children }) {
  const navigate = useNavigate();
  
  useEffect(() => {
   api.get("auth",{ headers: auth.token() }).then((response) => {
    
    }).catch(error =>{
      if(error.response.status === 401){
        auth.logout(()=>{
         /*  api.post('logout', auth.token()  ,{ headers: auth.token() }).then((response) => {
            console.log(response)
          }) */
          navigate("/");
        });
      }
    });
    return 0;
  }, [navigate]);

  return auth.token() && auth.type() === "admin" ? (
    children
  ) : (
    <Navigate to="/" />
  );
}
